// Plan types based on the backend get_plan_type function
// Priority: Teams > Pro > Pro Trial > Free
export const planTypes = [
  { value: 'teams', label: 'Teams' },
  { value: 'pro', label: 'Pro' },
  { value: 'pro_trial', label: 'Pro Trial' },
  { value: 'free', label: 'Free' },
];

// Predefined use cases for LLM configuration
export const predefinedUseCases = {
  firstPassGeneration: {
    title: 'Aura - Initial note generation',
    description:
      'Configure LLMs used in the master prompt that generates the initial note',
    settings: {
      verbosity: {
        title: 'Verbosity',
        options: ['Comprehensive', 'Balanced', 'Concise'],
        promptScreenMapping: {
          comprehensive: [
            'ambient_in_visit_summary',
            'ambient_in_visit_summary_regeneration',
            'ambient_in_visit_summary_comprehensive_op',
            'ambient_in_visit_summary_regeneration_comprehensive_op',
          ],
          balanced: [
            'ambient_in_visit_summary_balanced',
            'ambient_in_visit_summary_regeneration_balanced',
            'ambient_in_visit_summary_balanced_op',
            'ambient_in_visit_summary_regeneration_balanced_op',
          ],
          concise: [
            'ambient_in_visit_summary_concise',
            'ambient_in_visit_summary_regeneration_concise',
            'ambient_in_visit_summary_concise_op',
            'ambient_in_visit_summary_regeneration_concise_op',
            'ambient_in_visit_summary_regeneration_concise',
          ],
        },
      },
    },
  },
  secondPassGeneration: {
    title: 'Aura - Note section enhancement',
    description:
      'Configure LLMs used in the 2nd+ pass, i.e section-wise refinement of initial note',
    settings: {
      verbosity: {
        title: 'Verbosity',
        options: ['Comprehensive', 'Balanced', 'Concise'],
        promptScreenMapping: {
          comprehensive: [
            'ambient_in_visit_summary_enrich_sections_comprehensive',
            'ambient_in_visit_summary_enrich_sections_comprehensive_op',
          ],
          balanced: [
            'ambient_in_visit_summary_enrich_sections_balanced',
            'ambient_in_visit_summary_enrich_sections_balanced_op',
          ],
          concise: [
            'ambient_in_visit_summary_enrich_sections_concise',
            'ambient_in_visit_summary_enrich_sections_concise_op',
          ],
        },
      },
    },
  },
};
